import {CommandBase} from '@shared/commands/command-base';
import {TranslationConfig} from "../translation-config";


export class ConvertHtmlToPdfCommand extends CommandBase {
  constructor(public translationId: string,
              public htmlFileId: string,
  public fileName: string) {
    super(TranslationConfig.getHtmlToPdfApi());
  }
}

